import {
    GET_CUSTOMER_REQUEST,
    GET_CUSTOMER_RECEIVE_DATA,
    GET_CUSTOMER_REQUEST_FAILED
} from "../actions/get-customer-actions";

const initialState = {
    customer: null,
    isLoading: false,
    error: null
};

export default function getCustomerReducer(state = initialState, action) {
    switch (action.type) {
        case GET_CUSTOMER_REQUEST:
            return { ...state, isLoading: true, error: null };
        case GET_CUSTOMER_RECEIVE_DATA:
            return {
                ...state,
                isLoading: false,
                customer: action.payload,
                error: null
            };
        case GET_CUSTOMER_REQUEST_FAILED:
            return { ...state, isLoading: false, error: action.payload, customer: null };
        default:
            return state;
    }
}
